import React from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";

export default function WelcomeDialog({ open, onClose }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Dialog
      fullWidth
      fullScreen={fullScreen}
      maxWidth="md"
      open={open}
      onClose={onClose}
    >
      <AppBar position="static" color="default">
        <Toolbar>
          <Typography variant="h6" style={{ flex: 1 }}>
            Welcome to Ginástica TV!
          </Typography>
          <IconButton edge="end" onClick={onClose} size="large">
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <DialogContent>
        <Box sx={{ p: 2, textAlign: "center" }}>
          <Typography variant="h4" gutterBottom>
            Welcome to the new Ginástica TV!
          </Typography>

          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.6 }}>
            We&apos;ve had a makeover — a faster, more modern platform with lots
            of new features.
          </Typography>

          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.6 }}>
            You&apos;re in the right place – we&apos;ve only changed our digital
            home.
          </Typography>

          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.6 }}>
            If you experience any issues, thank you for your patience while we
            fine-tune everything.
          </Typography>

          <Typography
            variant="body1"
            sx={{ fontWeight: "bold", lineHeight: 1.6 }}
          >
            Thanks for being part of our community!
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

WelcomeDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
